/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
-----------------------------------------------------------------------------*/

<template>
  <svg
    id="micIconSvg"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    preserveAspectRatio="xMidYMid meet"
  >
    <clipPath
      id="myClip"
    >
      <rect
        id="micIconClip"
        x="0"
        y="100%"
        width="100%"
        height="100%"
      />
    </clipPath>
    <clipPath
      id="bg"
    >
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
      />
    </clipPath>

    <g
      id="mic"
    >
      <path
        d="M4.58579 0.585786C4.96086 0.210714 5.46957 0 6 0C6.53043 0 7.03914 0.210714 7.41421 0.585786C7.78929 0.960859 8 1.46957 8 2V6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6V2C4 1.46957 4.21071 0.960859 4.58579 0.585786ZM6 1C5.73478 1 5.48043 1.10536 5.29289 1.29289C5.10536 1.48043 5 1.73478 5 2V6C5 6.26522 5.10536 6.51957 5.29289 6.70711C5.48043 6.89464 5.73478 7 6 7C6.26522 7 6.51957 6.89464 6.70711 6.70711C6.89464 6.51957 7 6.26522 7 6V2C7 1.73478 6.89464 1.48043 6.70711 1.29289C6.51957 1.10536 6.26522 1 6 1Z"
      />
      <path
        d="M2.5 4.5C2.77614 4.5 3 4.72386 3 5V6C3 6.79565 3.31607 7.55871 3.87868 8.12132C4.44129 8.68393 5.20435 9 6 9C6.79565 9 7.55871 8.68393 8.12132 8.12132C8.68393 7.55871 9 6.79565 9 6V5C9 4.72386 9.22386 4.5 9.5 4.5C9.77614 4.5 10 4.72386 10 5V6C10 7.06087 9.57857 8.07828 8.82843 8.82843C8.07828 9.57857 7.06087 10 6 10C4.93913 10 3.92172 9.57857 3.17157 8.82843C2.42143 8.07828 2 7.06087 2 6V5C2 4.72386 2.22386 4.5 2.5 4.5Z"
      />
      <path
        d="M6 9C6.27614 9 6.5 9.22386 6.5 9.5V11.5C6.5 11.7761 6.27614 12 6 12C5.72386 12 5.5 11.7761 5.5 11.5V9.5C5.5 9.22386 5.72386 9 6 9Z"
      />
      <path
        d="M3.5 11.5C3.5 11.2239 3.72386 11 4 11H8C8.27614 11 8.5 11.2239 8.5 11.5C8.5 11.7761 8.27614 12 8 12H4C3.72386 12 3.5 11.7761 3.5 11.5Z"
      />
    </g>

    <use
      clip-path="url(#bg)"
      xlink:href="#mic"
      fill="black"
    />
    <use
      clip-path="url(#myClip)"
      xlink:href="#mic"
      fill="#318EBB"
    />
  </svg>
</template>

<style lang="less" scoped>
  #micIconSvg {
    height: 125px;
    width: 125px;
  }
</style>

<script>

export default {
  data() {
    return {};
  },
};
</script>
